<template>
  <div class="wrap">
    <div class="d-flex">
      <div class="mr-auto">
        <button class="btn btn-secondary" @click="refresh"><i class="fas fa-sync-alt"></i></button>
        <slot name="buttons"></slot>
      </div>
      <div class="align-self-end">
        <input-debounced
          v-model="search"
          :clearable="true"
          :autofocus="true"
          placeholder="Search"
          class="search-bar w-300 mb-2"
        ></input-debounced>
      </div>
    </div>
    <base-table
      :base-url="urlWithFilters"
      ref="baseTable"
      @load-success="onLoadSuccess"
      @refresh="onRefresh"
      :current-page="currentPage"
      v-loading="isRefreshing"
      element-loading-spinner="el-icon-loading"
    >
      <template v-slot>
        <el-table
          :data="items"
          stripe
          class="w-100"
        >
          <el-table-column
            prop="model.id"
            label="Id"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="model.first_name"
            label="First Name"
            min-width="100"
            show-tooltip-when-overflow
          ></el-table-column>
          <el-table-column
            prop="model.last_name"
            label="Last Name"
            min-width="100"
            show-tooltip-when-overflow
          ></el-table-column>
          <el-table-column
            prop="model.filemaker_id"
            label="Filemaker ID"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="model.note"
            label="Notes"
            width="80"
            v-slot="{row}"
          >
            <note-column :row="row" @show-list="onShowNoteList" @stored="onNoteStored"></note-column>
          </el-table-column>
          <el-table-column
              prop="model.email_context"
              label="Email context"
              min-width="100"
              show-tooltip-when-overflow
          ></el-table-column>
          <el-table-column
            prop="model.email"
            label="Email"
            min-width="150"
            show-tooltip-when-overflow
          ></el-table-column>
          <el-table-column
            prop="model.phone_number"
            label="Phone Number"
            width="180"
            v-slot="{row}"
          >
            <phone-number-column :row="row"></phone-number-column>
          </el-table-column>
          <el-table-column
            prop="model.status"
            label="Status"
            width="80"
            v-slot="{row}"
          >
            <status-column :row="row"></status-column>
          </el-table-column>
          <el-table-column
            prop="model.created_at"
            label="Created at"
            width="120"
            :formatter="formatDate"
          ></el-table-column>
          <el-table-column
            label="Actions"
            v-slot="{row}"
            width="120"
          >
            <actions-column :row="row" @edit="onEdit" @delete="onDelete"></actions-column>
          </el-table-column>
        </el-table>
      </template>
    </base-table>
    <el-pagination
      layout="prev, pager, next"
      :total="total"
      :current-page.sync="currentPage"
      :page-size="pageSize"
      class="text-right"
    ></el-pagination>
    <dialog-note-list></dialog-note-list>
  </div>
</template>

<script>
import TableWithPagination from '../table-with-pagination';
import {addQueryParams} from '../../libs/url';
import ActionsColumn from './actions-column';
import StatusColumn from './status-column';
import PhoneNumberColumn from './phone-number-column';
import DialogNoteList from './dialog-note-list';
import NoteColumn from './note-column';

export default {
  extends: TableWithPagination,

  components: {
    ActionsColumn,
    StatusColumn,
    PhoneNumberColumn,
    DialogNoteList,
    NoteColumn,
  },

  data() {
    return {
      search: null,
      filters: {},
    };
  },

  computed: {
    /**
     * @return {string}
     */
    urlWithFilters() {
      return addQueryParams(this.url, this.filters);
    },
  },

  watch: {
    search: function (value) {
      this.filters = value
        ? _.assign({}, this.filters, {search: value})
        : this.filters = _.omit(this.filters, ['search']);
    },
  },

  methods: {
    /**
     * @param {object} row
     * @param {object} col
     * @param {string} datetime
     * @return {string}
     */
    formatDate(row, col, {datetime}) {
      return moment(datetime).format(config('format.moment.short.datetime'));
    },

    /**
     * @return {undefined}
     */
    refresh() {
      this.$refs.baseTable.refresh();
    },

    /**
     * @param {string} url
     * @event show-add-contact-dialog
     */
    onEdit({url}) {
      eventBus.$emit('show-add-contact-dialog', url);
    },

    /**
     * @param {string} url
     */
    onDelete({url}) {
      axios.post(url, {_method: 'DELETE'})
        .then(({data: {message}}) => {
          _.isString(message) && this.$message.success(message);
          this.refresh();
        })
        .catch((err) => {
          const message = _.get(err, 'response.data.message');
          _.isString(message) && this.$message.error(message);
        });
    },

    /**
     * @param {string} url
     * @event show-note-index-dialog
     */
    onShowNoteList({url}) {
      eventBus.$emit('show-note-index-dialog', url);
    },

    /**
     * @param {number} index
     * @param {object} model
     */
    onNoteStored({index, model}) {
      this.$set(this.items[index].model, 'note', model);
    },
  }
}
</script>
